import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateProductAssessmentAssignee = {
  name: "updateProductAssessmentAssignee" as const,
  input: z.object({
    returnId: zExt.objectId(),
    productId: z.string(),
    definitionId: zExt.objectId(),
    assignee: zExt.objectId().nullable(),
  }),
  output: z.object({
    success: z.boolean(),
    productAssessment: z.object({
      assessmentDefinitionId: zExt.objectId(),
      assignee: zExt.objectId().nullable(),
    }),
  }),
};
